"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.screenShotDisplayObject = screenShotDisplayObject;
var _pixi = require("pixi.js");
function screenShotDisplayObject(renderer, displayObject, height, width) {
  var tex = _pixi.RenderTexture.create({
    width: height,
    height: width
  });
  renderer.render(displayObject, {
    renderTexture: tex
  });
  renderer.plugins.extract.canvas(tex).toBlob(function (b) {
    var a = document.createElement('a');
    document.body.append(a);
    a.download = "test";
    a.href = URL.createObjectURL(b);
    a.click();
    a.remove();
  }, 'image/png');
}
//# sourceMappingURL=screenShotDisplayObject.js.map